module.exports = __webpack_public_path__ + "img/double_arrow_up.be68cbf3.svg";